// extracted by mini-css-extract-plugin
export var charcoal = "languageSelector-module--charcoal--82240";
export var chevron = "languageSelector-module--chevron--44d6a";
export var cotton = "languageSelector-module--cotton--c7815";
export var currentLanguage = "languageSelector-module--currentLanguage--4c816";
export var currentLanguageName = "languageSelector-module--currentLanguageName--47676";
export var languageCountry = "languageSelector-module--languageCountry--d0910";
export var languageList = "languageSelector-module--languageList--2d9c1";
export var languageMenu = "languageSelector-module--languageMenu--a925a";
export var languageSelector = "languageSelector-module--languageSelector--d019f";
export var link = "languageSelector-module--link--554bd";
export var listItem = "languageSelector-module--listItem--c5797";
export var open = "languageSelector-module--open--1f2e2";